import styled from 'styled-components';
import { transparentize } from 'polished';

import PerfectScrollbar from 'react-perfect-scrollbar';
import { ButtonBase } from 'components/Button/styles';

interface ScrollProps {
  height?: string;
}
export const Container = styled.div`
  /* background: ${props => props.theme.cardBackgroud}; */
  width: -webkit-fill-available;
  height: -webkit-fill-available;
  width: -moz-available;
  display: flex;
  flex-direction: column;


  >header{
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 10px;
    div{
      display: flex;
      align-items: center;
      min-width: 250px;
      width: 100%;
    }
    h4{
      min-width: 130px;
    }
  }
`;

export const Header = styled.div`
  flex-grow: auto;
  display: flex;
  padding-bottom: 10px;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  ${ButtonBase} {
    margin: 0 10px 0 0 !important;
    min-width: 170px !important;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
  thead {
    tr {
      th {
        text-align: left;
        padding: 10px 0px;
        color: ${props => props.theme.fontColor};
        font-size: 1.0625rem;
        font-weight: 400 !important;
      }
    }
  }

  tbody {
    tr {
      border-bottom: 0.1px solid
        ${props => transparentize(0.7, props.theme.fontColor)};
      &:last-of-type {
        border-bottom: none;
      }
      td {
        padding: 10px 0px;

        font-size: 1.0625rem;
        color: ${props => props.theme.fontColor};

        button {
          margin: 0;
        }
      }
    }
  }
`;

export const Scroll = styled(PerfectScrollbar)<ScrollProps>`
  height: ${props => (props.height ? props.height : 'auto')};
  padding: 0 1rem;
`;
